export class CheckinRequestModel {
    ssn: string;

    constructor(ssn: string = '') {
        this.ssn = ssn;
    }
}
